import type { TabItem } from '@/component/Tab'
import Tab from '@/component/Tab'
import WalletContext from '@/context/WalletContext'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector } from '@/store/PopupStore'
import type { CurrencyCode } from '@kulee/tga-sdk/types/types/wallet'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TradeRecords from '../TradeRecords'

const TradeRecordMain: React.FC<PropType> = () => {
  const { t } = useTranslation('wallet')
  const { wallet } = useContext(WalletContext)
  const { active } = useStatePopup(PopupSelector.billingPopup)
  const [items, setItems] = useState<TabItem[]>([])

  useEffect(() => {
    const items: TabItem[] = []
    if (!wallet) {
      return
    }

    Object.keys(wallet).map(code => {
      items.push({
        label: t(`currency.${code.toLowerCase()}`),
        key: code,
        children: <TradeRecords key={code} currency={code as CurrencyCode} />
      })
    })

    setItems(items)
  }, [wallet])

  return (
    <Tab
      items={items}
      activeKey={active?.toLowerCase()}
      className="flex h-full flex-col"
      barClassName="px-md"
      destroyInactive
      contentClassName="flex-grow h-full rounded-t-2xl bg-white py-md pl-md text-[#002231]"
    />
  )
}

interface PropType {}

export default TradeRecordMain
